import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { Estate } from '../utils/enum.util';
import { BikeService2 } from '../services/bike2.service';

export class BikeModel {

    private _id: string      = null;
    private _created: Date;
    private _clientPrivateId = null;
    private _brand           = null;
    private _model           = null;
    private _numCad          = null;
    private _size            = null;
    private _comment         = null;
    private _used: boolean   = true;
    private _errors: any[];

    private _state: any = {
        brand  : Estate.Noting,
        model  : Estate.Noting,
        numCad : Estate.Noting,
        size   : Estate.Noting,
        comment: Estate.Noting
    };

    private _notSave:boolean;

    public antiMultiPost:boolean = false;



    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public _bikeService2: BikeService2, notSave = false) {
        this._notSave = notSave;
    };

    //*************************************
    //*************** ACTION **************
    //*************************************

    public modelChange(field: string) {
        //TODO : Anti rebond
        if (this._id == null)
            return this.create();
        this.updateOnField(field);
    }

    private updateOnField(field: string) {
        this.state[field] = Estate.Noting;
        if (this.validate() || !this.errors[field]) {
            this._bikeService2.put(this, field);
        }
    }

    private create() {
        if (this.validate() && !this.antiMultiPost) {
            this.antiMultiPost = true;
            this._bikeService2.post();
        }
        if (this.antiMultiPost)
            console.log('antidoublon');
    }

    static j2o(data, bikeService, notSave = false) {
        let bike              = new BikeModel(bikeService);
        bike._id              = data.id;
        bike._created         = data.created;
        bike._clientPrivateId = data._clientPrivateId;
        bike._brand           = data.brand;
        bike._model           = data.model;
        bike._numCad          = data.numCad;
        bike._size            = data.size;
        bike._used            = data.used;
        bike._comment         = data.comment;

        bike.state.brand   = Estate.Save;
        bike.state.model   = Estate.Save;
        bike.state.numCad  = Estate.Save;
        bike.state.size    = Estate.Save;
        bike.state.comment = Estate.Save;

        bike.notSave = notSave;

        return bike;
    }

    static o2j(bike: BikeModel) {
        let tmp = {
            id             : null,
            created        : null,
            clientPrivateId: null,
            brand          : null,
            model          : null,
            numCad         : null,
            size           : null,
            used           : null,
            comment        : null
        };
        if (bike) {
            tmp.id             = bike.id;
            tmp.created        = bike.created;
            tmp.clientPrivateId= bike.clientPrivateId;
            tmp.brand          = bike.brand;
            tmp.model          = bike.model;
            tmp.numCad         = bike.numCad;
            tmp.size           = bike.size;
            tmp.used           = bike.used;
            tmp.comment        = bike.comment;
        }
        return tmp;
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this._brand, 'brand', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._model, 'model', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._numCad, 'numCad', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._size, 'size', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._comment, 'comment', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._used, 'used', EvalidatorRequire.Require, [
                {fn: validator.boolean, options: {}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //************** METHOD ***************
    //*************************************


    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get errors(): any[] {
        return this._errors;
    }

    set errors(value: any[]) {
        this._errors = value;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get created(): Date {
        return this._created;
    }

    set created(value: Date) {
        this._created = value;
    }

    get clientPrivateId(): any {
        return this._clientPrivateId;
    }

    set clientPrivateId(value: any) {
        this._clientPrivateId = value;
    }

    get brand(): any {
        return this._brand;
    }

    set brand(value: any) {
        this._brand = value;
    }

    get model(): any {
        return this._model;
    }

    set model(value: any) {
        this._model = value;
    }

    get numCad(): any {
        return this._numCad;
    }

    set numCad(value: any) {
        this._numCad = value;
    }

    get size(): any {
        return this._size;
    }

    set size(value: any) {
        this._size = value;
    }

    get used(): boolean {
        return this._used;
    }

    set used(value: boolean) {
        this._used = value;
    }

    get state(): any {
        return this._state;
    }

    set state(value: any) {
        this._state = value;
    }

    get comment(): any {
        return this._comment;
    }

    set comment(value: any) {
        this._comment = value;
    }

    get notSave(): boolean {
        return this._notSave;
    }

    set notSave(value: boolean) {
        this._notSave = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/bike.model.ts